<template>
<div>
    <v-container fluid>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-container class="d-flex justify-center">
                <v-btn color="red darken-1" class="white--text mx-2" outlined @click="openNewTab('staff-stock-request')">
                    Staff Stock Requests
                </v-btn>

                <v-btn color="blue darken-2" class="white--text mx-2" outlined @click="openNewTab('stock-register')">
                    Stock Register
                </v-btn>

                <v-btn color="grey darken-2" class="white--text mx-2" outlined @click="openNewTab('staff-stock-logs')">
                    Staff Stock Logs
                </v-btn>

                <v-btn color="green darken-2" class="white--text mx-2" outlined @click="openNewTab('student-stock-logs')">
                    Student Stock Logs
                </v-btn>
            </v-container>
        </v-card>

        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Stock-Dashboard</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <br>
            <v-row justify="center" dense>
                <!-- Organization Dropdown -->
                <v-col cols="12" sm="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="org" :items="org_list" item-text="name" item-value="id" outlined persistent-hint hint="Please Select Organization" :rules="[v => !!v || 'Organization is required']">
                        <template v-slot:label>
                            <span class="required">Organization *</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <!-- Vendor Dropdown (Filtered by Organization) -->
                <v-col cols="12" sm="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="invVendor" :items="filteredVendorList" item-text="company_name" item-value="id" outlined persistent-hint hint="Please Select Vendor" :rules="[v => !!v || 'Vendor is required']">
                        <template v-slot:label>
                            <span class="required">Vendor *</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <!-- Shop Dropdown (Filtered by Selected Vendor) -->
                <v-col cols="12" sm="3">
                    <v-autocomplete color="#0F2027" dense rounded required v-model="supplierShop" :items="filteredSupplierShopList" item-text="name" item-value="id" outlined persistent-hint hint="Please Select Shop" :rules="[v => !!v || 'Shop is required']">
                        <template v-slot:label>
                            <span class="required">Shop *</span>
                        </template>
                    </v-autocomplete>
                </v-col>

                <!-- Proceed Button -->
                <v-col cols="12" sm="3" v-if="invVendor && supplierShop">
                    <v-btn color="primary" rounded outlined @click="proceed">Proceed</v-btn>
                </v-col>
            </v-row>

        </v-card>

        <v-card class="box" v-if="stockData!=''">
            <v-card-title>
                <v-text-field v-model="search" label="Search" prepend-inner-icon="mdi-magnify" single-line hide-details clearable></v-text-field>
            </v-card-title>

            <v-data-table :headers="headers" :items="stockData" :search="search" item-value="id" class="elevation-1 mytable">
                <template v-slot:[`item.action`]="{ item }">
                    <!-- Disable "Issue" icon when availableQuantity is 0 or less -->
                    <v-icon size="25" class="mr-2" :class="{ 'disabled-icon': item.availableQuantity <= 0 }" :disabled="item.availableQuantity <= 0" @click="item.availableQuantity > 0 && openEditDialog(item, 'issue')">
                        mdi-hand-coin
                    </v-icon>
                    <v-icon size="25" @click="openEditDialog(item, 'return')">
                        mdi-restore
                    </v-icon>
                </template>
                <template v-slot:[`item.stockRegister`]="{ item }">
                    <v-icon size="25" class="mr-2" @click="openNewTab('stock-register')">
                        mdi-eye
                    </v-icon>
                </template>
            </v-data-table>
        </v-card>

        <!-- Edit Stock Dialog -->
        <!-- Dialog for Issue/Return Stock -->
        <v-dialog v-model="editDialog" max-width="900px">
            <v-card>
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>{{ dialogMode === 'issue' ? 'Issue Stock' : 'Return Stock' }}</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-form ref="editForm">
                        <v-row justify="center" class="mt-4">
                            <!-- Read-Only Fields -->
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.vendor" readonly label="Vendor *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.vendorShop" readonly label="Vendor Shop *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.itemCategory" readonly label="Item Category *"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="mt-4">
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.itemName" readonly label="Item Name *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.sizeLabelType" readonly label="Size Label Type *"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded outlined v-model="selectedStock.sizeLabel" readonly label="Size Label *"></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="mt-4">
                            <v-col cols="12" sm="3">
                                <v-autocomplete dense rounded v-model="selectedStock.academicYear" :items="ayList" item-text="ay" item-value="id" outlined persistent-hint hint="Please Select Academic Year" :rules="[v => !!v || 'Academic Year is required']">
                                    <template v-slot:label>
                                        <span>Academic Year *</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-autocomplete dense rounded v-model="selectedStock.staff" :items="facultyList" item-text="name" item-value="id" outlined persistent-hint hint="Please Select Staff" :rules="[v => !!v || 'Staff is required']">
                                    <template v-slot:label>
                                        <span>Staff *</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded v-model="selectedStock.issueDate" :label="dialogMode === 'issue' ? 'Issue Date *' : 'Return Date *'" type="date" outlined :rules="[v => !!v || 'Date is required']">
                                    <template v-slot:label>
                                        <span>{{ dialogMode === 'issue' ? 'Issue Date *' : 'Return Date *' }}</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense rounded v-model="selectedStock.quantity" :label="dialogMode === 'issue' ? 'Quantity *' : 'Return Quantity *'" type="number" outlined :rules="[v => !!v || 'Quantity is required']">
                                    <template v-slot:label>
                                        <span>{{ dialogMode === 'issue' ? 'Quantity *' : 'Return Quantity *' }}</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row justify="center" class="mt-4">
                            <v-col cols="12" sm="6">
                                <v-textarea dense rounded v-model="selectedStock.remark" label="Remark" outlined>
                                    <template v-slot:label>
                                        <span>Remark</span>
                                    </template>
                                </v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="editDialog = false">Cancel</v-btn>
                    <v-btn color="primary" :loading="loader" :disabled="!isFormValid" @click="saveStockAction">{{ dialogMode === 'issue' ? 'Issue Stock' : 'Return Stock' }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</div> <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        search: '',
        loader: false,
        editDialog: false,
        dialogMode: 'issue', // Tracks whether dialog is for "issue" or "return"
        selectedStock: {},
        facultyList: [],
        stockData: [], // Your stock data from API
        vendorList: [], // Vendor list from API
        standardList: [], // Standard list from API
        itemCategoryList: [], // Item Category list
        sizeLabelTypesList: [], // Size Label Types
        sizeLabelsList: [], // Size Labels
        itemList: [], // Size Labels
        ayList: [], // Academic Year list
        org_list: [],
        org: "",
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        supplierShopList: [],
        supplierShop: "",
        invVendorList: [],
        invVendor: "",
        stockData: [],
        headers: [{
                text: "S.No",
                value: "id"
            },
            {
                text: "Vendor",
                value: "vendor"
            },
            {
                text: "Vendor Shop",
                value: "vendorShop"
            },
            {
                text: "Item Category",
                value: "itemCategory"
            },
            {
                text: "Item Name",
                value: "itemName"
            },
            {
                text: "Standard",
                value: "standard"
            },
            {
                text: "Size Label Type",
                value: "sizeLabelType"
            },
            {
                text: "Size Label",
                value: "sizeLabel"
            },
            {
                text: "Available Quantity",
                value: "availableQuantity"
            },
            {
                text: "Stock Register",
                value: "stockRegister"
            },
            {
                text: "Action",
                value: "action",
                sortable: false
            }
        ]
    }),
    methods: {
        saveStockAction() {
            if (this.dialogMode === 'issue') {
                this.saveIssueStock();
            } else {
                this.saveReturnStock();
            }
        },
        saveReturnStock() {
            // Prepare payload
            const payload = {
                ...this.selectedStock
            };
            this.overlay = true;
            this.loader = true;
            axios.post("/EduStore/saveReturnStock", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Stock Issued Successfully!");
                        this.editDialog = false;
                        this.proceed(); // Refresh stock data after saving
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        if (res.data.error_trace) {
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error saving stock:", error);
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                    this.loader = false;
                });
        },
        saveIssueStock() {
            // Check if the requested quantity exceeds the available quantity
            if (this.selectedStock.availableQuantity < this.selectedStock.quantity) {
                this.showSnackbar("red", "Insufficient stock available!");
                return; // Stop execution if stock is insufficient
            }
            // return
            // Prepare payload
            const payload = {
                ...this.selectedStock
            };
            this.overlay = true;
            axios.post("/EduStore/saveIssueStockToFaculty", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("green", "Stock Issued Successfully!");
                        this.editDialog = false;
                        this.proceed(); // Refresh stock data after saving
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        if (res.data.error_trace) {
                            sessionStorage.setItem("error-trace", res.data.error_trace);
                        }
                    }
                })
                .catch((error) => {
                    console.error("Error saving stock:", error);
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        openEditDialog(item, mode = 'issue') {
            this.selectedStock = {
                ...item,
                //quantity: 1, // Default quantity set to 1
                issueDate: new Date().toISOString().substr(0, 10), // Default to today's date
                returnDate: new Date().toISOString().substr(0, 10) // Added return date for return mode
            };

            this.dialogMode = mode; // Set the mode ('issue' or 'return')
            this.editDialog = true;
        },
        openNewTab(routeName) {
            let routeData = this.$router.resolve({
                name: routeName
            });
            window.open(routeData.href, "_blank");
        },
        proceed() {
            // Prepare payload directly from filteredItemList
            const payload = {
                invVendor: this.invVendor,
                supplierShop: this.supplierShop,
                organization: this.org
            };

            this.overlay = true;
            axios.post("/EduStore/getStockData", payload)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.stockData = res.data.stockData;

                        // Populate lists from API response
                        //this.vendorList = res.data.vendorList || [];
                        this.standardList = res.data.standardList || [];
                        //this.itemCategoryList = res.data.itemCategoryList || [];
                        // this.itemList = res.data.itemList || [];
                        // this.sizeLabelTypesList = res.data.sizeLabelTypesList || [];
                        //this.sizeLabelsList = res.data.sizeLabelsList || [];
                        this.ayList = res.data.ayList || [];
                        this.facultyList = res.data.instructorList || [];
                        this.selectedStock.academicYear = res.data.current_ay
                    } else if (res.data.flag === "No") {
                        this.showSnackbar("red", res.data.snackbar);
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        onLoad() {
            axios.post("EduStore/getStockDetails")
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.invVendorList = res.data.invVendorList;
                        this.supplierShopList = res.data.supplierShopList;
                        this.org_list = res.data.org_list
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
    computed: {
        // Filter vendor list based on selected organization
        isFormValid() {
            return this.selectedStock.academicYear &&
                this.selectedStock.staff &&
                this.selectedStock.issueDate &&
                this.selectedStock.quantity > 0;
        },
        filteredVendorList() {
            if (!this.org) return [];
            return this.invVendorList.filter(vendor => vendor.org_id === this.org);
        },
        // Filter shop list based on selected vendor
        filteredSupplierShopList() {
            if (!this.invVendor) return [];
            return this.supplierShopList.filter(shop => shop.invvendorId === this.invVendor);
        },
        filteredItems() {
            return this.itemList.filter(
                (item) => item.itemcategoryId === this.selectedStock.itemCategory
            );
        },
        filteredSizeLabels() {
            return this.sizeLabelsList.filter(
                (label) => label.sizelabeltypeid === this.selectedStock.sizeLabelType
            );
        },
    },
    watch: {},
};
</script>

<style scoped>
.required {
    color: red;
}

.v-btn {
    min-width: 200px;
    font-weight: bold;
}
.disabled-icon {
  opacity: 0.5;
  pointer-events: none;
}
</style>
